/*
 * @Descripttion:
 * @Author: zhangtingjiang
 * @Date: 2019-12-10 17:04:32
 */
export default {
  namespaced: true,
  state: {
    title: {
      activityName: '',
      groupName: '',
      scheduleTime: ''
    }
  },
  mutations: {
    SETTITLE (state, value) {
      let { activityName, groupName, scheduleTime } = value
      state.title = {
        activityName,
        groupName,
        scheduleTime
      }
    }
  },
  actions: {
    dispatchChangeTitle ({ commit }, value) {
      commit('SETTITLE', value)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/onside.js